var key_value_state = {
  namespaced: true,
  state() {
    return {
      hasInitialData: false,
      items: [],
      limit: null,
      totalCount: null
    };
  },
  mutations: {
    setLimit(state, limit) {
      state.limit = limit;
    },
    setTotalCount(state, total_count) {
      state.totalCount = total_count;
    },
    setInitialItems(state, { items, idOfItem, sortOrder }) {
      state.hasInitialData = true;
      var duplicate_check = {};
      var new_items = [];
      for (let item of items) {
        if (duplicate_check[idOfItem(item)] == null) {
          new_items.push(item);
          duplicate_check[idOfItem(item)] = item;
        }
      }

      if (state.limit != null && state.limit >= items.length && state.items.length > items.length) {
        //if we currently have more items than we are getting from intial data, keep the remaining as is (keep fetch more position so it doesn't reset on server reconnect).
        for (let item of state.items.slice(items.length, state.items.length)) {
          if (duplicate_check[idOfItem(item)] == null) {
            new_items.push(item);
            duplicate_check[idOfItem(item)] = item;
          }
        }
      }

      if (sortOrder != null) new_items = new_items.sort(sortOrder);
      if (state.limit != null) new_items = new_items.slice(0, state.limit);
      state.items = new_items;

      state.totalCount = null; //total count may have increased
    },
    addItems(state, { items, idOfItem, sortOrder }) {
      var duplicate_check = {};
      var new_items = [];
      for (let item of items) {
        if (duplicate_check[idOfItem(item)] == null) {
          duplicate_check[idOfItem(item)] = item;
        }
      }
      for (let item of state.items) {
        if (duplicate_check[idOfItem(item)] == null) {
          new_items.push(item);
          duplicate_check[idOfItem(item)] = item;
        }
      }
      for (let item of items) {
        new_items.push(item);
      }
      if (sortOrder != null) new_items = new_items.sort(sortOrder);
      if (state.limit != null) new_items = new_items.slice(0, state.limit);
      state.items = new_items;

      state.totalCount = null; //total count may have increased
    },
    updateItems(state, { items, idOfItem, sortOrder }) {
      var to_update_map = {};
      for (let item of items) {
        to_update_map[idOfItem(item)] = item;
      }

      var new_items = [];
      for (let item of state.items) {
        if (to_update_map[idOfItem(item)] == null) {
          new_items.push(item);
        } else {
          new_items.push(to_update_map[idOfItem(item)]);
        }
      }
      if (sortOrder != null) new_items = new_items.sort(sortOrder);
      state.items = new_items;
    },
    removeItems(state, { itemIds, idOfItem }) {
      var to_remove_map = {};
      for (let item_id of itemIds) {
        to_remove_map[item_id] = item_id;
      }

      let new_items = [];
      for (let item of state.items) {
        var ix = idOfItem(item);
        if (to_remove_map[ix] != ix) {
          new_items.push(item);
        }
      }
      state.items = new_items;
    },
    reorderItem(state, { itemId, beforeItemId, idOfItem }) {
      let all_items_map = {};
      let item_to_reorder = null;
      let before_item = null;
      for (let item of state.items) {
        all_items_map[idOfItem(item)] = item;
      }
      item_to_reorder = all_items_map[itemId];
      if (beforeItemId) {
        before_item = all_items_map[beforeItemId];
      }
      if (item_to_reorder) {
        let new_items = [];
        for (let item of state.items) {
          if (before_item && idOfItem(item) === idOfItem(before_item)) {
            new_items.push(item_to_reorder);
          }
          if (idOfItem(item) !== idOfItem(item_to_reorder)) {
            new_items.push(item);
          }
        }
        if (!before_item) new_items.push(item_to_reorder);
        state.items = new_items;
      }
    }
  },
  getters: {
    list: state => {
      return state.items;
    },
    hasInitialData: state => {
      return state.hasInitialData;
    },
    totalCount: state => {
      return state.totalCount;
    }
  },
  actions: {
    subscribe(context, subscribe) {
      context.commit('setLimit', subscribe.limit);
      var sub = subscribe.subscribe();
      return sub;
    }
  }
};

var currentSubscriptions = {};

let Vue = null;

function vueSet(array, key, value) {
  if (Vue) {
    Vue.set(array, key, value);
  } else {
    array[key] = value;
  }
}

function vueDelete(array, key) {
  if (Vue) {
    Vue.delete(array, key);
  } else {
    delete array[key];
  }
}

export default {
  namespaced: true,
  init: function (vue) {
    Vue = vue;
  },
  state() {
    return {
      initializedLists: {}
    };
  },
  mutations: {
    setInitialized(state, store_path) {
      vueSet(state.initializedLists, store_path, store_path);
    },
    setUninitialized(state, store_path) {
      vueSet(state.initializedLists, store_path, null);
    }
  },
  getters: {
    initializedLists(state) {
      return state.initializedLists;
    }
  },
  actions: {
    subscribe(context, subscribe) {
      var id_str = subscribe.storePath;
      var existing_subscription = currentSubscriptions[id_str];

      var update_store_limit = () => {
        let sub = currentSubscriptions[id_str];
        if (sub == null) return;

        let max_limit = 0;
        for (let sub_data of sub.subscriberData) {
          if (sub_data.limit == null) {
            max_limit = null;
            break;
          } else {
            if (sub_data.limit > max_limit) {
              max_limit = sub_data.limit;
            }
          }
        }

        context.commit(id_str + "/setLimit", max_limit);
      };

      let subscriber_data = {
        limit: subscribe.limit
      };

      if (existing_subscription == null) {
        var vuex_module_name = "liststore/" + id_str;
        console.log("Registering liststore vuex store at " + vuex_module_name);
        this.registerModule(vuex_module_name, key_value_state);
        context.commit('setInitialized', id_str);
        var sub = context.dispatch(id_str + "/subscribe", subscribe);
        var sub_obj = {
          subscription: sub,
          subscriberData: []
        };

        sub_obj.unsubscribe = () => {
          let subscriber_data_index = sub_obj.subscriberData.indexOf(subscriber_data);
          sub_obj.subscriberData.splice(subscriber_data_index, 1);
          if (sub_obj.subscriberData.length == 0) {
            sub_obj.subscription.then(sub => sub.unsubscribe());
            console.log("Unregistering liststore vuex store at " + vuex_module_name);
            this.unregisterModule(vuex_module_name);
            context.commit('setUninitialized', id_str);
            currentSubscriptions[id_str] = null;
          } else {
            update_store_limit();
          }
        };

        currentSubscriptions[id_str] = sub_obj;
        existing_subscription = sub_obj;
      }

      existing_subscription.subscriberData.push(subscriber_data);

      return {
        unsubscribe: existing_subscription.unsubscribe,
        setLimit: limit => {
          subscriber_data.limit = limit;
          update_store_limit();
        }
      };
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/store/liststore.js
// module id = null
// module chunks = 